import React from 'react';
import ReactQuill from 'react-quill';
import PropTypes from 'prop-types';

const Editor = ({ content, setContent }) => {
  const handleChange = (html) => {
    if (html == '<br>')
      setContent('');
    else
      setContent(html);
  };

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline']
    ]
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
  ];

  React.useEffect(() => {
    const quillContainer = document.querySelector('.ql-container.ql-snow');
    if (quillContainer) {
      quillContainer.style.minHeight = '200px';
      quillContainer.style.maxHeight = '450px';
      quillContainer.style.overflowY = 'scroll';
    }
  }, []);


  return (
    <>
      <ReactQuill
        onChange={handleChange}
        theme="snow"
        modules={modules}
        formats={formats}
        value={content}
        placeholder='Type here...'
      />
    </>
  );
};

Editor.propTypes = {
  content: PropTypes.string,
  setContent: PropTypes.function
};

export default Editor;
